import { Colors, Text } from '@amelio/ui-library';

import type { ContentLanguage } from '@/utils/contentLanguage';

import { useAmelioTranslations } from '@/hooks';

interface AgendaLanguageLabelProps {
    /** The one language the agenda is written in. */
    agendaLanguage: ContentLanguage;
    /** The reader's language: the label shows only when the agenda is written in the other one. */
    readerLanguage: ContentLanguage;
}

/**
 * Says which language the agenda is written in, for a reader whose own language is the other one: an
 * agenda keeps the language it was created or generated in, and is never translated for its reader.
 */
export const AgendaLanguageLabel = ({
    agendaLanguage,
    readerLanguage,
}: AgendaLanguageLabelProps) => {
    const { t } = useAmelioTranslations();

    if (agendaLanguage === readerLanguage) {
        return null;
    }

    return (
        <Text
            size={'small'}
            color={Colors.BASE_500}
            className={'mt-2'}
            data-testid={'agenda-language-label'}
        >
            {t(
                agendaLanguage === 'fr'
                    ? 'meetingAgenda.writtenInLanguage.fr'
                    : 'meetingAgenda.writtenInLanguage.en',
            )}
        </Text>
    );
};
